import React from "react";
import ReactDOM from "react-dom";
import { ModalContext } from "./modalContext";

import "../../css/modal.scss";

const Modal = () => {
  let { modalContent, handleModal, modal } = React.useContext(ModalContext);
  if (modal) {
    return ReactDOM.createPortal(
      <div className="modal">
        <div className="top-ctn" onClick={handleModal} />

        <div className="center-ctn">
          <div className="left-ctn" onClick={handleModal} />
          {modalContent}
          <div className="right-ctn" onClick={handleModal} />
        </div>
        <div className="bottom-ctn" onClick={handleModal} />
      </div>,
      document.querySelector("#modal-root")
    );
  } else return null;
};

export default Modal;
